module.exports = __webpack_public_path__ + "img/ELC-logo-only.300cdee8.gif";